import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	mode: '',
};

const preferThemeSlice = createSlice({
	name: 'preferTheme',
	initialState,
	reducers: {
		toggleMode: (state, action) => {
			state.mode = action.payload;
		},
	},
});

export const { toggleMode } = preferThemeSlice.actions;

export default preferThemeSlice.reducer;
